// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Uh4VorYD5dMB9rQSDv1q{padding:4px;position:relative}.Uh4VorYD5dMB9rQSDv1q:before{z-index:var(--zIndex-BASE_10);background-color:var(--border-neutral-default);content:"";height:1px;position:absolute;bottom:0;left:0;right:0}.MBPLcYVAEIMGYGhrITxk{padding:4px;position:relative}.MBPLcYVAEIMGYGhrITxk:before{z-index:var(--zIndex-BASE_10);background-color:var(--border-neutral-default);content:"";height:1px;position:absolute;bottom:0;left:0;right:0}.MBPLcYVAEIMGYGhrITxk:last-of-type:before{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"head": `Uh4VorYD5dMB9rQSDv1q`,
	"section": `MBPLcYVAEIMGYGhrITxk`
};
export default ___CSS_LOADER_EXPORT___;
